let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kEd6d")).then(() => parcelRequire('efnEv'));